import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';

import { useAppSelector } from 'src/hooks/useStore';
import { RootState } from 'src/store';
import { isUnreadNotification } from 'src/utils/NotificationsUtils';

const selectInvoiceNotifications = createSelector(
  (state: RootState) => state.notifications.newInvoiceNotifications,
  (state: RootState) => state.activeCompany.activeCompanyId,
  (apiNotifications, activeCompanyId) =>
    apiNotifications.filter((notif) => notif.companyId === activeCompanyId),
);

export const useInvoicesNotificationCount = (): number => {
  const isClient = useAppSelector((state: RootState) => state.user.isClient);
  // Get the notifications from the store according to the user role
  const notifications = useAppSelector(selectInvoiceNotifications);

  return useMemo(() => {
    if (!isClient) return 0;

    const unreadNotifications = notifications.filter((notif) =>
      isUnreadNotification(notif.ownerId),
    );
    return unreadNotifications.length;
  }, [isClient, notifications]);
};
